module.exports = __webpack_public_path__ + "static/img/336.514334c6.jpg";